import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-harddrive",
  "use": "icon-th-harddrive-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-harddrive\">\n<path d=\"M28 8H4C3.46957 8 2.96086 8.21071 2.58579 8.58579C2.21071 8.96086 2 9.46957 2 10V22C2 22.5304 2.21071 23.0391 2.58579 23.4142C2.96086 23.7893 3.46957 24 4 24H28C28.5304 24 29.0391 23.7893 29.4142 23.4142C29.7893 23.0391 30 22.5304 30 22V10C30 9.46957 29.7893 8.96086 29.4142 8.58579C29.0391 8.21071 28.5304 8 28 8ZM28 22H4V10H28V22ZM25 16C25 16.2967 24.912 16.5867 24.7472 16.8334C24.5824 17.08 24.3481 17.2723 24.074 17.3858C23.7999 17.4993 23.4983 17.5291 23.2074 17.4712C22.9164 17.4133 22.6491 17.2704 22.4393 17.0607C22.2296 16.8509 22.0867 16.5836 22.0288 16.2926C21.9709 16.0017 22.0007 15.7001 22.1142 15.426C22.2277 15.1519 22.42 14.9176 22.6666 14.7528C22.9133 14.588 23.2033 14.5 23.5 14.5C23.8978 14.5 24.2794 14.658 24.5607 14.9393C24.842 15.2206 25 15.6022 25 16Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-harddrive.svg
// module id = L5vf
// module chunks = 84